import React from "react";
import "./mobileMenyList.scss";
import { menuList } from "../../../data/menuList";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const MobileMenuList = ({ openMenu, setOpenMenu }) => {
    const navigate = useNavigate();

    const permissions = useSelector((state) => state.status.permissions);

    const [activeMenuItem, setActiveMenuItem] = useState(0);

    const onLinkClickHandler = (link) => {
        setActiveMenuItem(0);
        setOpenMenu(false);
        navigate(link);
    };

    const openListItemHendler = (id) => {
        activeMenuItem === id ? setActiveMenuItem(0) : setActiveMenuItem(id);
    };

    return (
        <div className={openMenu ? "mobile-menu-list mobile-menu-list-active" : "mobile-menu-list"}>
            {menuList.map((listItem) => {
                return (
                    <div className="mobile-menu-list__item" key={listItem.name}>
                        <div className="mobile-menu-list__item-title" onClick={() => openListItemHendler(listItem.id)}>
                            {listItem.name}
                        </div>
                        {listItem.id === activeMenuItem ? (
                            <div className="mobile-menu-list__item-sub">
                                {listItem.links.map((link) => {
                                    if (permissions.includes(link.permission) || permissions.includes("all")) {
                                        return (
                                            <div
                                                className="mobile-menu-list__item-sub-link"
                                                onClick={() => onLinkClickHandler(link.link)}
                                            >
                                                {link.name}
                                            </div>
                                        );
                                    }
                                })}
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default MobileMenuList;
